<template>
  <div class="signin">
    <div class="login-part">
      <!-- <UserNav page="/users-signin"/> -->
      <Navbar  page-name="فراموشی رمز" custome_class="border" burger="true" v-once>
      <div slot="button" class="ty-flex ty-gap-4 align-items-center">
          <router-link :to="{name: 'landing-root'}">
            <ty-button radius="10px" type="outline" class="p-1 p-sm-2" color="light"><span class="fs-10 fs-sm-12 fs-md-16 ty-color-gray">صفحه اصلی</span></ty-button>
          </router-link>
          <a href="tel:+982128429693">
            <ty-button radius="10px" class="py-1 px-2 py-sm-2 px-sm-3" color="light"><i class=" ty-color-primary ty-icon ty-icon-call"/></ty-button>
          </a>
        </div>
      </Navbar>
      <div class="login-container">
        <forgot-password-form class="login-form" v-once />
      </div>
      <!-- <SiteFooter/> -->
    </div>
    <div class="back-part"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import SiteFooter from '@/components/Footer.vue';
import Navbar from "../components/Navbar.vue";
import ForgotPasswordForm from '../components/ForgotPasswordForm.vue';
// import "@/assets/styles/login.css";
export default {
  name: "login",
  components: {
    ForgotPasswordForm,
    Navbar,
  },
  methods: {
    auth() {
      this.$store.dispatch("auth");
    },
  },

  mounted() {
    this.$gtag.pageview({page_title: this.$route.name, page_location: this.$route.fullPath, page_path: this.$route.path})
  }
};
</script>
<style scoped>
.signin {
  display: flex;
  height: 100vh;
}
.login-part{
  width: 70%;
  position: relative;
}
.back-part{
  width: 30%;
  background: #f9f9f9;
  background-image: url('../assets/images/shop_tayeh.svg');
}
.login-container {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
}
body {
  background: #eee;
}
@media (max-width: 820px) {
				.signin {
  display: block;
}
.login-part{
  width: 100%;
  height: 100vh;
}
.back-part{
  display: none;
}
			}
</style>
